import BasicLayout from '@/layouts/basic-layout';

const meta = {
    auth: true
};

const pre = 'basic-';

export default {
    path: '/basic',
    name: 'basic',
    redirect: {
        name: `${pre}account`
    },
    meta,
    component: BasicLayout,
    children: [
        {
            path: 'account',
            name: `${pre}account`,
            meta: {
                ...meta,
                title: '用户管理',
                closable: true
            },
            component: () => import('@/pages/basic/account')
        },
        {
            path: 'authority',
            name: `${pre}authority`,
            meta: {
                ...meta,
                title: '角色管理',
                closable: true
            },
            component: () => import('@/pages/basic/authority')
        },
        {
            path: 'menu',
            name: `${pre}menu`,
            meta: {
                ...meta,
                title: '菜单管理',
                closable: true
            },
            component: () => import('@/pages/basic/menu')
        }
    ]
};
